module.exports = __webpack_public_path__ + "img/wuyefei.1e19ce93.png";